import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";

import { regions as actionsRegions  } from "../../store/actions";
const { setSelectedRegion } = actionsRegions;

const RegionsSelector = ({ title }) => {

    const dispatch = useDispatch();

    let selectedRegion = useSelector(store => store.regions.selectedRegion);
    let regions = useSelector(store => store.regions.items);

    useEffect(() => {
        if (! selectedRegion || selectedRegion?.id == -1) {
            if (regions.length) {
                dispatch(setSelectedRegion(regions[0]));
            }
        }
    }, [regions]);

    const selectRegion = e => {
        const idRegion = e.target.value;
        const region = regions.find(item => Number(item.id) === Number(idRegion));
        dispatch(setSelectedRegion(region));
    };

    return (
        <div>
            { title && (   
                <div className="text-lg p-2 bg-gray-900">
                    { title }
                </div>
            )}
            <div className="flex items-center px-2">
                <div className="flex-1 text-right px-2">
                    Region
                </div>
                <div className="flex-auto">
                    { 
                        <select value={selectedRegion.id} onChange={selectRegion} className="p-2 my-1 bg-gray-800 border border-gray-700 w-full">
                            {regions.map(region => {
                                return <option value={region.id} key={region.id}>{region.name}</option>
                            })}
                        </select>
                    }
                </div>
            </div>
        </div>
    );
}

export default RegionsSelector;